import debug from 'Helper/debugHelpers'
import { callbackWrapper } from 'actions/apiActions'
import { call, select } from 'redux-saga/effects'
import defaultCallbacksImport from './defaultCallback'
import Store from '../store'

const redactStrings = ['password', 'password_confirmation', 'passwordConfirmation']
// This function is called by xtractAPIsagas and looks at the result of an api call.
// It starts an array with the default callback functions (all declared above) and then
// overrides those with any user customized callbacks that were attached to this
// particular api call. It then executes any callbacks that are appropriate based on
// the actual status code that was returned by the api call.
export default function * checkResult(response, action) {
  debug.logObject('checking result on: ', response, debug.logLevels.API)
  const status = response.status
  const userCallbacks = action.callbacks || []
  if (
    action.config &&
    action.config.windowRef &&
    action.config.cancelable !== false
  ) {
    // the action came from a window so we should see if the window is still open before
    // executing its callbacks.
    const api = yield select(state => state.api)
    if (api.callers.indexOf(action.config.windowRef) === -1) {
      // its no longer in the list which means the pending api calls were cancled so we shouldn't execute
      // the callbacks
      return null
    }
  }
  // log to console if error
  if (status !== 200) {
    let redactedAction = { ...action }
    if (typeof action === 'object') {
      redactedAction = redactStrings.reduce((action, redactString) => {
        if (Object.keys(action).indexOf(redactString) !== -1) {
          action[redactString] = '** redacted **'
        }
        return action
      }, redactedAction)
    }
    debug.logObject(
      'API responded with status:' + status,
      redactedAction,
      debug.logLevels.API,
      'warn'
    )
  }
  // make a duplicate so we can maintain a list of the default callbacks
  const defaultCallbacks = { ...defaultCallbacksImport }
  // now override the default callback with any user provided callback for the same key

  if (typeof userCallbacks[status] === 'function') { defaultCallbacks[status] = userCallbacks[status] } else if (([200, 201, 202, 204]).indexOf(status) !== -1 && typeof userCallbacks.success === 'function') {
    defaultCallbacks[status] = userCallbacks.success
  } else if (([400, 422]).indexOf(status) !== -1 && typeof userCallbacks.validation === 'function') {
    defaultCallbacks[status] = userCallbacks.validation
  } else if (([401, 403, 419, 404, 429, 500, 503, 504]).indexOf(status) !== -1 && typeof userCallbacks.error === 'function') {
    defaultCallbacks[status] = userCallbacks.error
  } else if (([401, 403, 419, 404, 429, 500, 503, 504]).indexOf(status) !== -1 && typeof userCallbacks.failure === 'function') {
    defaultCallbacks[status] = userCallbacks.failure
  } else if (typeof userCallbacks.error === 'function') {
    defaultCallbacks.default = userCallbacks.error
  } else if (typeof userCallbacks.failure === 'function') {
    defaultCallbacks.default = userCallbacks.failure
  }

  // Now see if the callback exists and call the appropriate function
  if (defaultCallbacks[status] != null) {
    yield call(defaultCallbacks[status], response, action, () => {
      Store.dispatch(callbackWrapper(defaultCallbacksImport[status], arguments))
    })
    return ([200, 201, 202, 204]).includes(status) ? response.data : null
  } else {
    // there was no callback for this status so use the default
    yield call(defaultCallbacks.default, response, action, () =>
      Store.dispatch(
        callbackWrapper(defaultCallbacksImport.default, arguments)
      )
    )
    return null
  }
}
